"use strict";
/**
 * Common sensor reading types
 */
Object.defineProperty(exports, "__esModule", { value: true });
